import { graphql } from 'react-relay';

export const AIPresetQuery = graphql`
    query aiPresetQuery($id: ID!) {
        aiPreset(id: $id) {
            id
            name
            previewUrl
            imageUrl
        }
    }
`;
